/**
 * sl-728o.6.1: Trigger Factories for Onboarding Demo Tour
 *
 * Reusable factory functions that create TutorialTrigger objects.
 * Each factory encapsulates a specific user interaction pattern.
 */
import type { TutorialTrigger } from '../../types';

/** Fires when the user switches editor mode to the target mode (e.g. 'edgeless' or 'page') */
export function createViewSwitchTrigger(targetMode: string): TutorialTrigger {
  return { type: 'view-switch', mode: targetMode };
}

/** Fires when the user scrolls the canvas in the given direction */
export function createScrollTrigger(
  direction: 'up' | 'down' | 'left' | 'right'
): TutorialTrigger {
  return { type: 'scroll', direction };
}

/** Fires when the user selects at least minCount elements on the canvas */
export function createSelectionTrigger(minCount: number): TutorialTrigger {
  return { type: 'select', minCount };
}

/** Fires when the user opens the AI chat sidebar or copilot panel */
export function createAiChatTrigger(): TutorialTrigger {
  return { type: 'custom', eventName: 'ai-chat-open' };
}

/** Fires when the user changes the database view (e.g. switches from table to kanban) */
export function createViewChangeTrigger(): TutorialTrigger {
  return { type: 'custom', eventName: 'database-view-change' };
}

/** Fires when the user enters presentation mode */
export function createPresentationTrigger(): TutorialTrigger {
  return { type: 'custom', eventName: 'presentation-start' };
}
